import { Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteValue } from '../../models/autocomplete-value.model';
import { map, switchMap } from 'rxjs';

@Component({
  selector: 'ez-email-input',
  imports: [ReactiveFormsModule],
  templateUrl: './email-input.component.html',
  styleUrl: './email-input.component.scss',
})
export class EmailInputComponent {
  private readonly rootFormGroup = inject(FormGroupDirective);

  readonly isDisabled = input<boolean>(false);
  readonly name = input<string>();
  readonly controlName = input.required<string>();
  readonly labelledBy = input<string>();

  readonly control = computed<AbstractControl>(() => this.form.get(this.controlName())!);

  readonly errorMessage = toSignal(
    toObservable(this.control).pipe(switchMap((control) => control.events.pipe(map(() => this.currentErrorMessage())))),
    { initialValue: null },
  );

  get form(): FormGroup {
    return this.rootFormGroup.control;
  }

  private currentErrorMessage(): string | null {
    const control = this.control();
    if (!control.invalid || !(control.dirty || control.touched)) {
      return null;
    }
    if (control.errors?.['email']) {
      return 'Fehler: Die eingegebene E-Mail ist fehlerhaft. Bitte überprüfen Sie Ihre Eingabe.';
    }
    return 'Fehler: Dies ist ein Pflichtfeld. Wir benötigen Ihre E-Mail-Adresse, um Ihnen vorab die nötigen Informationen für den Vertragsabschluss zustellen zu können.';
  }

  protected readonly AutocompleteValue = AutocompleteValue;
}
